<script lang="ts" setup>
import { Button } from '~ds/components/ui/button';
import { Heading, Text } from '~ds/components/ui/typography';
import { useI18n } from 'vue-i18n';

interface Props {
  email: string;
  loading: boolean;
}

defineProps<Props>();

const emit = defineEmits<{
  chooseOtp: [];
  choosePassword: [];
  back: [];
}>();

const { t } = useI18n();
</script>

<template>
  <div
    class="flex flex-col items-center"
    data-testid="auth-method-step"
  >
    <Heading
      size="xl"
      as="h1"
      class="text-center mb-3"
    >
      {{ t('kui.auth.confirmItsYou') }}
    </Heading>
    <Text size="lg" class="text-center">
      {{ t('kui.auth.methodDescription') }}
    </Text>
    <Text size="lg" class="text-center font-medium">
      {{ email }}
    </Text>
    <Button
      class="mb-6"
      variant="link"
      size="sm"
      type="button"
      :disabled="loading"
      data-testid="auth-method-back"
      @click="emit('back')"
    >
      {{ t('general.auth.changeEmailButton') }}
    </Button>
    <Button
      class="w-full"
      variant="secondary"
      size="lg"
      type="button"
      :loading="loading"
      data-testid="auth-method-otp"
      @click="emit('chooseOtp')"
    >
      {{ t('kui.auth.emailMeACode') }}
    </Button>
    <Button
      class="mt-3 w-full"
      variant="outline"
      size="lg"
      type="button"
      :disabled="loading"
      data-testid="auth-method-password"
      @click="emit('choosePassword')"
    >
      {{ t('kui.auth.usePasswordInstead') }}
    </Button>
  </div>
</template>
